<a class="appname" routerLink="/" aria-label="Home Page">
  <app-logo [size]="38"></app-logo>
  <app-site-name></app-site-name>
</a>

<ul>
  <li><a routerLink="/" aria-label="Home Page">Home</a></li>
  <li>
    <a routerLink="/search" [queryParams]="{category_ids:1}">Dresses</a>
  </li>
  <li><a routerLink="/search" [queryParams]="{category_ids:2}">Tops</a></li>
  <li><a routerLink="/search">Shop</a></li>
  <li><a routerLink="/about-us">About</a></li>
</ul>
